/**
 * Tymes4 Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CustomerRelationshipTypeEnum = 1 | 2;

export const CustomerRelationshipTypeEnum = {
    Group: 1 as CustomerRelationshipTypeEnum,
    Company: 2 as CustomerRelationshipTypeEnum
};

